import React from 'react';
import { ContentBlock } from '../../../../common/index.jsx';
import { useTranslation } from 'react-i18next';

const PollAnswered = ({ data, hasJustVoted = false }) => {
  const { t } = useTranslation();
  return (
    <div className="news-detail-page-container add-icons-to-file-anchors">
      <ContentBlock
        contentVisible
        blockWrapper="block-wrapper"
        contentWrapper="content-wrapper"
        shadow
        title={data.name}
      >
        <>
          {hasJustVoted
            ? t(
                'Ďakujeme za vašu účasť v ankete. Výsledky budú dostupné po ukončení ankety.',
              )
            : t(
                'V tejto ankete ste už hlasovali. Ďakujeme za vašu účasť, výsledky budú dostupné po ukončení ankety.',
              )}
        </>
      </ContentBlock>
    </div>
  );
};
export default PollAnswered;
